// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/index.css
// module id = fCJj
// module chunks = 1